import { useEffect } from 'react';

import { keyConstants } from '../../utils';

const { TAB } = keyConstants;
const KEYCODE_TAB = 9;

const useFocusTrap = ({
    popoverContentRef, optionsMenuRef, isPopoverOpen,
}) => {

    useEffect(() => {

        if(!isPopoverOpen) {

            return;

        }

        const focusTrap = (event) => {

            const isTabPressed = (event.key === TAB || event.keyCode === KEYCODE_TAB);

            if (!isTabPressed) {

                return;

            }

            // query all elements on the keydown event as the contents change in the lifecicle of the popover content...
            // alternatively we could set up a mutation observer, or only visually hide the delete reel button, or I am sure other options...
            const focusableEls = Array.from(popoverContentRef.current.querySelectorAll('button:not([disabled])'));
            const firstFocusableEl = focusableEls[0];
            const lastFocusableEl = focusableEls[focusableEls.length - 1];
            const isAtBeginning = document.activeElement === optionsMenuRef.current || !focusableEls.includes(document.activeElement);

            if (event.shiftKey) /* shift + tab */ {

                if(isAtBeginning) {

                    lastFocusableEl.focus();
                    event.preventDefault();

                } else if (document.activeElement === firstFocusableEl) {

                    optionsMenuRef.current.focus();
                    event.preventDefault();

                }

            } else /* tab */ {

                if(isAtBeginning) {

                    firstFocusableEl.focus();
                    event.preventDefault();

                } else if (document.activeElement === lastFocusableEl) {

                    optionsMenuRef.current.focus();
                    event.preventDefault();

                }

            }

        };

        document.addEventListener('keydown', focusTrap);

        return () => {

            document.removeEventListener('keydown', focusTrap);

        };

    }, [
        popoverContentRef,
        optionsMenuRef,
        isPopoverOpen,
    ]);

};

export default useFocusTrap;
